import { useQuery } from '@tanstack/react-query';

interface PriceHistoryData {
  points: { price: number; recorded_at: string }[];
  changeLabel: string | null;
  changePercent: number | null;
}

export function usePriceHistory(domain: string) {
  return useQuery<PriceHistoryData>({
    queryKey: ['price-history', domain],
    queryFn: async () => {
      const response = await fetch(`/api/domains/${encodeURIComponent(domain)}/price-history`);
      if (!response.ok) throw new Error('Failed to fetch price history');
      return response.json() as Promise<PriceHistoryData>;
    },
    enabled: domain.length > 0,
    staleTime: 60 * 60_000,
  });
}
